import { IPlaylistResponseDto } from "./playlists";

export enum BlockType {
  GENERAL_VOD = 0,
  FILM_FESTIVAL_VOD = 1,
  LIVE_STREAMS = 2,
  PLAYLIST = 3,
  AD = 4,
}

export interface IProfile {
  profileId: string;
  clientId: string;
  profileName: string;
  active: boolean;
  deleted: boolean;
  deletedAt: string | null;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  versionCount?: number;
}

export interface IVersion {
  versionId: string;
  profileId: string;
  versionName: string;
  isActive: number;
  blockCount?: number;
  blocksOrder: string[];
  createdAt: string;
  updatedAt: string;
}

export interface IBlock {
  blockId: string;
  versionId: string;
  profileId: string;
  type: BlockType;
  enabled: boolean;
  renderInfo: {
    templateId?: number;
    playlistId?: string;
  };
  payload?: any | IPlaylistResponseDto;
  createdAt: string;
  updatedAt: string;
}

export interface IProfilesResponse {
  data: {
    profiles: IProfile[];
    count: number;
  };
}

export interface IVersionsResponse {
  data: {
    versions: IVersion[];
    count: number;
  };
}

export interface IBlocksResponse {
  data: {
    blocks: IBlock[];
    count: number;
  };
}

export interface IProfileCreateRequest {
  profileName: string;
}

export interface IProfileUpdateRequest {
  profileId: string;
  profileName?: string;
  active?: boolean;
}

export interface IVersionCreateRequest {
  versionName: string;
}

export interface IVersionUpdateRequest {
  versionId: string;
  versionName?: string;
  isActive?: number;
}

export interface IBlockCreateRequest {
  type: BlockType;
  enabled: boolean;
  renderInfo: {
    templateId?: number;
  };
  payload?: {
    playlistId?: string;
  }
}

export interface IBlockUpdateRequest {
  blockId: string;
  type?: BlockType;
  enabled?: boolean;
  renderInfo?: {
    templateId?: number;
    playlistId?: string;
  };
  payload?: any;
}
